import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class MainScrollService {
    scrollChanged: EventEmitter<any> = new EventEmitter();
    scroll: any;

    constructor() { }

    get data(): any {
        return this.scroll;
    }
    set data(val: any) {
        this.scroll = val;
        this.scrollChanged.emit(val);
    }
}
